import { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import TextareaAutosize from 'react-textarea-autosize';
import DriverSelectStateful from "../../components/DriveSelectStateful";
import TimeInput from '../../components/TimeInput';
import { ensureKnown, createArrangementException, updateArrangementException, fetchArrangementsExceptions, deleteArrangementException } from '../../store/knownArrangementsSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import { dateToTimestamp } from '../../util';
import { useNavigate } from 'react-router-dom';



function EditException({ id, date }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [ description, setDescription ] = useState("");
    const [ depart, setDepart ] = useState("00:00");
    const [ driver, setDriver ] = useState(null);
    const [ loaded, setLoaded ] = useState(false);

    const _data = useSelector((state) => state.knownArrangements.arrangements);
    const data = _data[id];

    const _exceptions = useSelector((state) => state.knownArrangements.exceptionsList);
    const exception = _exceptions.find(
        exception => id == exception["arrangement_id"]
            && (date.trim() == exception["arrangement_exception_exception_date"])
    );

    const updating = !!exception;

    useEffect(() => {
        if(!data) {
            setLoaded(false);
            return;
        }

        if(updating) {
            setDescription(exception["arrangement_exception_description"]);
            setDepart(exception["arrangement_exception_depart"]);
            setDriver(exception["arrangement_exception_driver"]);
        } else {
            setDescription(data["arrangement_description"]);
            setDepart(data["arrangement_depart"]);
            setDriver(data["arrangement_driver"]);
        }

        setLoaded(true);
    }, [data, exception]);



    useEffect(() => {
        dispatch(ensureKnown({ id }));
        dispatch(fetchArrangementsExceptions({ id }));
    }, []);

    async function onCreateException() {
        const res = await unwrapResult(await dispatch(createArrangementException({
            id,
            date,
            depart,
            description,
            driver,
        })));

        if(!res) return;

        toast.success("Erand loodud!");
    }

    async function onEditException() {
        const res = await unwrapResult(await dispatch(updateArrangementException({
            id: exception["arrangement_exception_id"],
            depart,
            description,
            driver,
        })));

        if(!res) return;

        toast.success("Erand uuendatud!");
    }

    async function onDeleteException() {
        if(!window.confirm("Kas oled kindel, et soovid kustutada?")) return;

        const res = await unwrapResult(await dispatch(deleteArrangementException({
            id: exception["arrangement_exception_id"],
        })));

        if(!res) return;

        toast.success("Erand kustutatud!");
        navigate('/platform/schedule');
    }


    if(!loaded) return null;

    return (
        // <DataContainer actionTypes={[ 'knownArrangements/updateException', 'knownArrangements/createException' ]}>
            <div className="column g32">
                <div className="column">
                    <h2>{updating ? "Erandi muutmine" : "Erandi loomine"}</h2>
                    <p>Muuda regulaarvedu ainult kuupäeval <b>{date.split("-").reverse().join('.')}</b></p>
                </div>

                <div className="line g32 w100">
                    <div className="column g4 grow">
                        <b>Kirjeldus</b>
                        <TextareaAutosize spellCheck={false} minRows="3" style={{ resize: 'none', fontFamily: 'unset' }} placeholder='Täpsusta kui vaja' value={description} onChange={(e) => setDescription(e.target.value)} />
                    </div>

                    <div className="column g16 grow">
                        <div className="column g4">
                            <b>Juht</b>
                            <DriverSelectStateful value={driver} setValue={setDriver} />
                        </div>

                        <div className="column g4">
                            <b>Väljumine</b>
                            <TimeInput value={depart} onChange={setDepart} />
                        </div>
                    </div>
                </div>

                <div className="row g16" style={{ justifyContent: 'end' }}>
                    {updating ? (
                        <>
                            <button onClick={onDeleteException} style={{ backgroundColor: '#d4635b', borderColor: '#f4837b', color: '#fff' }}>Kustuta erand</button>
                            <button onClick={onEditException}>Salvesta muudatused</button>
                        </>
                    ) : (
                        <button onClick={onCreateException}>Loo erand</button>
                    )}
                </div>

                <p style={{ color: '#888', textAlign: 'center' }}>Erandi kustutamine jätab regulaarveo sellele kuupäevale järgi, kuid taastab selle tavapärase juhi, kirjelduse ja väljumisaja</p>
            </div>
        // </DataContainer>
    );
}

export default EditException;